"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = void 0;
const isBrowser = () => typeof window !== 'undefined' && typeof window.document !== 'undefined';
exports.isBrowser = isBrowser;
